module.exports = __webpack_public_path__ + "img/1-lrn-logo-190.a2d40787.svg";